module.exports = __webpack_public_path__ + "img/BF.06f107b1.png";